import { printVisibility } from '@/features/styles/lib/printStyles';
import { Box, Portal } from '@/ui';
import type { AnchorId } from './steps';
import { useAnchorRect } from './useAnchorRect';

type Props = {
  anchorId: AnchorId;
  /** The anchor edge the dimmed area starts at. The anchor itself stays lit. */
  from: 'bottom' | 'right';
};

/**
 * Dims the page past one edge of a control, for cards whose subject is a whole
 * bar or rail rather than a single button. The ring's own spotlight lights only
 * its box, which would darken the Sources tab's neighbours and the Magic chat
 * the card just opened; this leaves everything on the control's side of the edge
 * alone and dims what is beyond it.
 */
export const EdgeScrim = ({ anchorId, from }: Props) => {
  const rect = useAnchorRect(anchorId);

  if (!rect) return null;

  const isBelow = from === 'bottom';

  return (
    <Portal>
      <Box
        bg="rgba(17, 12, 40, 0.38)"
        bottom={0}
        data-onboarding-scrim=""
        left={isBelow ? 0 : `${rect.left + rect.width}px`}
        pointerEvents="none"
        position="fixed"
        right={0}
        sx={printVisibility.hide()}
        top={isBelow ? `${rect.top + rect.height}px` : 0}
        transition="top 0.15s ease, left 0.15s ease"
        // Under the ring and the card, over everything it is meant to dim.
        zIndex={23}
      />
    </Portal>
  );
};
